export default function findCardId(id, allCards) {
    return allCards.find(item => item.id === id);
}